/**
 * TanStack Query hooks for `campaign-read-endpoint`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignReadEndpointQueryKeys,
	type CreateCampaignReadEndpointBody,
	type ListCampaignReadEndpointResponse,
	type CampaignReadEndpointRow,
} from "./api";

export function useCampaignReadEndpointList(): UseQueryResult<ListCampaignReadEndpointResponse, Error> {
	return useQuery({
		queryKey: campaignReadEndpointQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignReadEndpointCreate(): UseMutationResult<CampaignReadEndpointRow, Error, CreateCampaignReadEndpointBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignReadEndpointQueryKeys.all });
		},
	});
}

export function useCampaignReadEndpointDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignReadEndpointQueryKeys.all });
		},
	});
}
